import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un email con el link de descarga. Acceso en menos de 5 minutos. Compatible con celular, tablet y computadora.'
}, {
  q: '¿Sirve si soy entrenador nuevo o si tengo experiencia?',
  a: 'Sirve para los dos casos. Si empezás ahora: tenés todo el sistema para no improvisar desde el primer día. Si tenés experiencia: te ahorra el tiempo de planificación y le da continuidad a lo que ya sabés hacer.'
}, {
  q: '¿Los 6 Bonos están en las dos opciones?',
  a: 'Sí. Los 6 Bonos están incluidos en el Pack Profesional y en el Megapack Élite. La diferencia del Élite son los 2 Ebooks adicionales: Pretemporada Blindada y Estrategia PRO.'
}, {
  q: '¿Qué diferencia hay con otros materiales que ya existen?',
  a: 'Rugby 360 es el único sistema diseñado específicamente para el entrenador amateur argentino. No son teorías importadas: son sesiones listas para usar en el campo, con la realidad de los clubes argentinos.'
}, {
  q: '¿Sirve para distintas categorías en el mismo club?',
  a: 'Sí. Tenés 14 tomos que cubren desde M6 hasta M23. Si entrenás más de una categoría, tenés el sistema completo para todas.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Garantía de 7 días sin preguntas. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin formularios, sin justificación, sin drama.'
}, {
  q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
  a: 'Si ya planificás bien, el Élite te da las dos herramientas que ningún sistema tiene: la pretemporada sistematizada y las jugadas de pizarrón para ganar partidos que no deberías ganar. Son los dos momentos donde la mayoría de los entrenadores pierde ventaja.'
}, {
  q: '¿Puedo pagar con tarjeta de crédito?',
  a: 'Sí. Aceptamos todas las tarjetas, débito y transferencia bancaria. Pago 100% seguro a través de Mercado Pago.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-20 px-4" data-id="element-69">
      <div className="max-w-3xl mx-auto" data-id="element-70">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12" data-id="element-71">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-72">
          {faqs.map((faq, i) => <div key={i} className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-73">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center bg-gray-50 hover:bg-gray-100 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-74">
                <span className="font-bold text-gray-900 text-lg pr-4" data-id="element-75">
                  {faq.q}
                </span>
                {openIndex === i ? <ChevronUp className="text-gray-500 flex-shrink-0" data-id="element-76" /> : <ChevronDown className="text-gray-500 flex-shrink-0" data-id="element-77" />}
              </button>
              <AnimatePresence data-id="element-78">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-79">
                    <div className="px-6 py-4 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-80">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}